<app-stages [stages]="stages" currentStage="Informacja"></app-stages>
<br>
@if (!pending() && !loading()) {
  <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)='submitAndGoNext()'>
    <div class='col-md-12'>
      <div class='form-group' *ngIf='"description" as controlName'>
        <label [for]='controlName'>
          Informacja *
        </label>
        <textarea
          rows="8"
          [id]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          [formControlName]='controlName'
          placeholder='Wpisz tu odpowiedż na wezwanie'>
          </textarea>
        <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
    <div class='application-actions'>
      <button
        type='button'
        class='btn btn-secondary'
        (click)='onCancel()'>
      <span>
        Wstecz
      </span>
      </button>
      <button
        type='submit'
        class='btn btn-primary'>
        <span>Zapisz i przejdź dalej</span>
      </button>
    </div>
  </form>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
